export const environment = {
    // graphQL
    url_api_graphql: 'https://graal.maasify.io/v2/graphql', // prod
    //url_api_graphql: 'https://leodagan.staging.maasify.io/graphql', // preprod
    token_client_api: 'bx!fvM;4x$hpw8@wQ7',

    // keycloak
    url_auth: 'https://auth.maasify.io/auth', // prod
    //url_auth: 'https://auth.staging.maasify.io/auth', // preprod
    clientAuth: 'mybus.io',
    clientAuthSecret: 'b30a6699-4ecf-45b4-b03d-94cded7eb53c', // prod
    //clientAuthSecret: '4356b713-9e5e-4312-b820-93d80745a386', // preprod

    // geocoder
    url_geocoder_api: 'https://atlas.microsoft.com/search/fuzzy/',

    // mqtt
    env_topic: 'prod',
    mqtt_url: 'mqtt.mybus.io', // prod obligatoire
    mqtt_port: 443,
    mqtt_client_prefix: "app_",

    // api
    url_api: 'https://api.mybus.io',
    token_client_id: '3_4lvu9vj18ko48c8occ4wscs8c8cs8ks088gc0go0skss0ws44k',
    token_client_secret: '4z59g68hpick4scckgk0s40o8kg4k44scg04c4swk04wwgg40',
}

